module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gZ7LC2/tc-custom/FC-9781528948005.jpg?1684514755677?1709061536086",
      "alt": "This image is the cover for the book Miracles of Spiritual Healing"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Miracles of Spiritual Healing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Casa de Dom Inacio is an internationally famous spiritual healing centre in Brazil. It was opened by Joao Teixeira de Farias about 40 years ago. Millions of people around the world have been visiting the place and got help for health problems and for other issues in their lives. The author of this book has also visited Casa three times and carried out a research on experiences of the visitors there, which are published in this book. Dr Sankelo tells also about her own experiences in Casa very openly in this excellent new book.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Merja Sankelo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Dr Merja Sankelo is a Finnish author who has a long scientific background in health research. She has been interested in spiritual-growth- and healing-related issues for many years. She decided to visit the famous spiritual healing centre Casa de Dom Inácio in Brazil and carried out a qualitative research focused on the experiences of visitors in Casa. The results are reported in this book.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0